import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import axios from 'axios';

import { BrowserRouter as Router } from 'react-router-dom';

import { default as auth } from './utils/auth';

import AppRoutes from './routes';

import './scss/styles.scss';
import { store } from './store';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use((config) => {
    let token = auth.getToken();
    let sessionKey = auth.getSID();
    let isJSONRequest = config.url.includes('.json');

    if (sessionKey && !isJSONRequest) {
        config.headers['Session-Key'] = sessionKey;
    }
    if (token && !isJSONRequest) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <AppRoutes />
        </Router>
    </Provider>,
    document.getElementById('root')
);
